export default __webpack_public_path__ + "static/media/slotsjungle.bbb60ee4.png";